import React from 'react';
import DonutSplitChart from './DonutSplitChart';

const RegionSplitChart = () => (
  <DonutSplitChart
    title="Split Over Region"
    endpoint="/dashboard/region-split"
    fixedCategories={[{ name: 'North' }, { name: 'South' }, { name: 'East' }, { name: 'West' }]}
    cornerLabel="% contribution"
  />
);

export default RegionSplitChart;
